module.exports = __webpack_public_path__ + "static/media/tools.dd47aa50.jpg";